import { render, staticRenderFns } from "./CorporateLenderPreamble.vue?vue&type=template&id=1fc96b00&"
import script from "./CorporateLenderPreamble.vue?vue&type=script&lang=js&"
export * from "./CorporateLenderPreamble.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports